// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__Pz3Zp","header":"ClearentDisclaimer_header__3eDEX","inner":"ClearentDisclaimer_inner__1QpA_"};